import React from 'react';
import { createRoot } from 'react-dom/client';
import { Modal, Group, Button, Text, MantineProvider } from '@mantine/core';

function ConfirmDialog({ opened, title, message, confirmLabel, cancelLabel, color, onClose }) {
  return (
    <Modal opened={opened} onClose={() => onClose(false)} title={title} centered>
      <Text mb="md">{message}</Text>
      <Group justify="flex-end">
        <Button variant="default" onClick={() => onClose(false)}>{cancelLabel}</Button>
        <Button color={color} onClick={() => onClose(true)}>{confirmLabel}</Button>
      </Group>
    </Modal>
  );
}

export function confirm({
  title = 'Confirm',
  message = 'Are you sure?',
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  color = 'red',
} = {}) {
  return new Promise((resolve) => {
    const container = document.createElement('div');
    document.body.appendChild(container);
    const root = createRoot(container);
    const handleClose = (result) => {
      try { root.unmount(); } catch {}
      try { document.body.removeChild(container); } catch {}
      resolve(result);
    };
    root.render(
      <MantineProvider>
        <ConfirmDialog
          opened
          title={title}
          message={message}
          confirmLabel={confirmLabel}
          cancelLabel={cancelLabel}
          color={color}
          onClose={handleClose}
        />
      </MantineProvider>
    );
  });
}
